<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
     <LogoHeader :logoPath="require('@/assets/logo/elm/elm-unicom.png')"
    altText="中国联通"/>
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img
        src="@/assets/GuangzhouUnicomImg/gzunion_head.jpg"
        class="topImg"
        alt=""
      />
      <div class="contentBox1">
        <div class="tcInfo">
          <div class="tcInfoBox">
            <div class="titleBox"><span class="bigText">29</span>元/月</div>
            <div class="contentBox">
              <div class="blueText"><span class="big">80</span>GB流量</div>
              <div class="text">30GB国内专属流量</div>
              <div class="text">50GB国内通用流量</div>
              <div class="smallText">
                （入网72小时内，一次性充值100元，每月享）
              </div>
              <div class="text">100分钟语音</div>
              <div class="smallText">
                （入网72小时内，一次性充值100元，每月享）
              </div>
            </div>
            <img
              class="sepeaker"
              src="@/assets/GuangzhouUnicomImg/speaker.png"
              alt=""
            />
            <img
              class="xpImg"
              src="@/assets/GuangzhouUnicomImg/xp.png"
              alt=""
            />
            <div class="bottomBg"></div>
          </div>
        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
                @click="showPicker = true"
              />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div>

        <div class="container">
          <div class="header">资费详情</div>
          <div class="content">
            <div class="zfxqTable">
              <div class="zTr">
                <div class="zTh">月费</div>
                <div class="zTd"><span class="blueText">29元/月</span></div>
              </div>
              <div class="zTr">
                <div class="zTh">流量</div>
                <div class="zTd">
                  <span class="blueText">80GB</span><br />
                  其中：<br />
                  30GB国内专属流量，自动到账<br />50GB国内通用流量，手动领取按指引
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">语音</div>
                <div class="zTd">
                  <span class="blueText">100分钟</span> <br />
                  (手动领取（按指引）)
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">套外资费</div>
                <div class="zTd">
                  <div>流量：国内流量1元/GB（日租宝）</div>
                  <div>语音：0.1元/分钟</div>
                  <div>短信：0.1元/条</div>
                </div>
              </div>
            </div>
            <div class="section">
              <h3>详细说明：</h3>

              <p>
                1、专属流量应用包含:腾讯系和非腾讯系,具体包括微信、手机QQ、腾讯新闻、腾讯视频、QQ音乐、QQ邮箱、企业邮箱，王者荣耀、英雄联盟手游、QQ游戏、快手、美团APP、美团外卖、小红书、酷狗音乐、喜马拉雅等近200款APP。
              </p>
              <p>
                2、具体查询路径如下：关注微信公众号“王卡助手”——服务——专属应用中心——专属应用推荐——查看全部应用。或者点击以下链接查询了解：
              </p>
              <a href="https://txwk.10010.com/wkpen/view/b6a7d6F63d.html "
                >https://txwk.10010.com/wkpen/view/b6a7d6F63d.html
              </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="header">优惠活动</div>
          <div class="content">
            <div class="section">
              <h3>活动说明：</h3>
              <p><strong>一、套餐、流量和语音领取路径及到账说明</strong></p>
              <p>1、套餐说明</p>
              <p>
                月租29元（按当月天数平均扣取月租费用，激活首月享受当月全量资源，月租计费=29元/当月天数*当月剩余天数）。
              </p>
              <p>2、流量说明</p>
              <p>
                （1）用户成功激活套餐后，每月享有30GB国内专属流量，自动到账。（专属流量不可结转至次月使用）、免费接听、全国无漫游费。
              </p>
              <p>
                （2）用户在京东、顺丰、邮政交付时充值≥100元，即可参与流量悦享活动，每月享有50GB国内通用流量。充值成功后用户可以到“王卡助手”微信公众号，输入关键词“流量悦享活动”，点击链接手动领取。可连续享受12个月，第13个月自动失效。
              </p>
              <p>3、语音说明</p>
              <p>
                用户在京东、顺丰、邮政交付时充值≥100元，即可参与流量悦享活动，每月享有100分钟国内语音通话时长。充值成功后用户可以到“王卡助手”微信公众号—特权—个人中心—业务办理—欠费不停机—领取语音。可连续享受12个月，第13个月自动失效。
              </p>
            </div>
            <div class="section">
              <p><strong>二、流量畅享活动相关说明</strong></p>
              <p>流量畅享活动入口、活动链接及二维码：</p>
              <p>仅限以下入口充值可参与活动：</p>
              <p>①联通公众APP开户成功页</p>
              <p>
                ②“王卡助手”微信公众号，输入关键词“流量悦享活动”，进入页面参与
              </p>
              <p>
                ③“宝卡服务”微信公众号，输入关键词“流量悦享活动”，进入页面参与
              </p>
              <p>④京东交付小哥处充值</p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>
                1、本业务向年满18-60周岁并使用身份证的用户办理，无身份证、黑名单用户等特殊群体无法办理，请知悉。
              </p>
              <p>
                2、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用
              </p>
              <p>
                3、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以联通系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
              <p>
                4、归属地：归属地随机，全国通用快递、邮政普通快递、顺丰、京东，随快递有激活指南一同寄出，自主激活即可。原则上无合约，但具体以号码归属当地省市分公司的交付政策为准。
              </p>
              <p>
                5、特别注意:部分APP享受免流服务前需先至对应APP进行绑定激活，专属流量使用范围可能因不可抗力或第三方原因发生变更，详情可前往“王卡助手”公众号了解。
              </p>
              <p>
                6、如需销户，可自行登录中国联通APP，搜索“销户”，按提示提交销户申请。也可持本人身份证，前往当地中国联通营业厅进行销户办理。
              </p>
              <p>7、销户原因产生违约金与否，以号码归属当地省市销户政策为准。</p>
              <p>
                8、用户充值成功后才可以领取流量，但由于充值消息有延迟，因此，用户充值后可能无法立刻成功领取流量，此延迟最长72小时。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="fzBox">
          <img class="fzImg" src="@/assets/fzImg.png" alt="" />
        </div>
      </div>
      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData.json";
import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "GuangzhouUnicom2",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [
        {
          name: "S",
          value: "S",
        },
        {
          name: "M",
          value: "M",
        },
        {
          name: "L",
          value: "L",
        },
        {
          name: "XL",
          value: "XL",
        },
        {
          name: "2XL",
          value: "2XL",
        },
        {
          name: "3XL",
          value: "3XL",
        },
        {
          name: "4XL",
          value: "4XL",
        },
        {
          name: "5XL",
          value: "5XL",
        },
      ],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      szData: {
        comboCode: "SZLT-LTWK2",
        spiId: "shenzhen-uni-01",
      },
      goodsName: "",
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = 1;
    // this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.columns = [];
    this.columns = operatorData[this.spiId].cardAttribution;
    // this.cardAttribution = this.columns[this.oIndex].text;
    // this.cardAttributionProvince = this.columns[this.oIndex].value;
    // this.cardAttributionCode = this.columns[this.oIndex].value;
    this.areaList = [];
    this.areaList.push(areaData["440000"]);
    // this.areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd"]);
    this.initAreaList2();
    this.comboData = operatorData[this.spiId].comboList[this.oIndex];
    this.comboName = this.comboData.comboName;
    this.goodsName = operatorData[this.spiId].goodsName;
    this.dealTextList = [
      {
        name: "入网协议",
        components: "unicomDeal9",
      },
      {
        name: "用户隐私协议",
        components: "ysxy",
      },
    ];
    this.simViewLogAdd();
    this.getActivityBySpi();
  },
  watch: {
    cardAttribution(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
      }
    },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //     let obj = {};
    //     let arr = [];
    //     console.log("newVal =>", newVal);
    //     if (newVal.includes("西藏") || newVal.includes("新疆")) {
    //       if (newVal.includes("西藏")) {
    //         obj = deepClone(areaData["540000"]);
    //       } else if (newVal.includes("新疆")) {
    //         obj = deepClone(areaData["650000"]);
    //       }

    //       this.contactsCity = "";
    //       this.areaData = [];
    //     } else {
    //       obj = deepClone(areaData["gzuni0000000001"]);
    //     }
    //     arr.push(obj);
    //     this.areaList = arr;
    //     console.log("areaList =>", this.areaList);
    //   }
    // },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: this.mtBmUid,
        spiId: this.spiId,
        clickName: "GZUnicom29",
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: this.mtBmUid,
        spiId: this.spiId,
        clickName: `ERROR-GZUnicom29-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href =
        "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
      // this.$router.push({
      //       name: "OrderList",
      //     });
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      // let noSubmit = true;
      // if (noSubmit) {
      //   return this.$toast(" 抱歉，本产品仅供骑手行业在岗用户，您本月无骑手跑单相关记录，本渠道不支持下单，敬请谅解。");
      // }

      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      let params = {
        comboLevel: this.comboData.comboLevel,
        comboName: this.comboData.comboName,
        cardAttribution: this.areaData2.cCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince: this.areaData2.pCode,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.comboData.comboCode,
        goodsCode: this.comboData.goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      if (this.areaData2.pCode != this.areaData.pCode) {
        this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
        return this.$toast("号码归属省份需和收货省份一致");
      }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
      if (this.areaData2.cCode == "440300") {
        this.comboData = {
          ...this.comboData,
          comboCode: this.szData.comboCode,
          goodsCode: this.szData.comboCode,
        };
        this.spiId = this.szData.spiId;
      } else {
        const gysCode = localStorage.getItem("gysCode");
        this.comboData = operatorData[gysCode].comboList[this.oIndex];
        this.spiId = gysCode;
      }
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      let params = {
        spiId: this.spiId,
        cityCode: this.areaData2.cCode,
        goodsId: this.comboData.comboCode,
        provinceCode: this.areaData2.pCode,
      };
      const { code, result, message } = await http(
        "ltZOPnumGuessSelect2",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(areaData["GDLT-CNDXBK"]);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";

.topImg {
    padding-top: 0px !important;
    width: 100%;
    display: block;
  }
</style>
